<template>
  <div class="page" :style="{ height: fixedHeight + 'px' }">
    <div class="searchbox">
      <div class="mr">
        <el-input
          style="width: 160px; margin-right: 10px; margin-left: 10px"
          placeholder="请输入名称"
          v-model="params.keyword"
          @keyup.enter.native="clickSearch"
          clearable
          size="small"
        ></el-input>
        <el-button
          @click="clickSearch"
          icon="el-icon-search"
          type="warning"
          size="small"
          >搜索</el-button
        >
      </div>
      <div class="mr">
        <el-select
          v-model="params.shopId"
          placeholder="请选择"
          clearable
          @change="clickSearch"
          size="small"
          style="width: 100px"
        >
          <el-option
            v-for="item in this.$store.state.userInfo.shops"
            :key="item.shop_id"
            :label="item.shop_name"
            :value="item.shop_id"
          >
          </el-option>
        </el-select>
      </div>
      <div style="text-align: right; flex: 1" class="mr">
        <!-- <el-button icon="el-icon-plus" type="primary" @click="addProductType('')">新建类型</el-button> -->
        <el-button
          icon="el-icon-plus"
          type="warning"
          @click="addGoods()"
          size="small"
          v-if="$buttonAuthority('chanpin-goods-add')"
          >新建商品</el-button
        >
      </div>
    </div>
    <div class="con" :style="{ height: fixedHeight - 82 + 'px' }">
      <div class="left" style="overflow-y: scroll">
        <el-button
          style="margin-left: 20px"
          size="mini"
          @click="addProductType('')"
          >添加</el-button
        >
        <el-button size="mini" type="warning" @click="resetProductType"
          >重置</el-button
        >
        <el-tree
          class="elTree"
          style="margin-top: 10px; height: 800px"
          v-if="categoryData[0]"
          :data="categoryData[0].children"
          :highlight-current="isHighlight"
          node-key="id"
          default-expand-all
          :expand-on-click-node="false"
          :render-content="renderContent"
          @node-click="handleNodeClick"
        >
        </el-tree>
      </div>

      <div class="table" style="overflow-y: scroll">
        <el-table :data="washData" style="width: 100%" size="small">
          <el-table-column prop="title" label="名称" width="160">
            <template slot-scope="scope">
              <div v-if="$public.isNull(scope.row.cover)">
                {{ scope.row.title }}
                {{ scope.row.buy_back == 0 ? "不复购" : "复购" }}
              </div>
              <el-tooltip v-else placement="top" effect="light">
                <div slot="content">
                  <img :src="scope.row.cover" style="width: 300px" />
                </div>
                <div>
                  {{ scope.row.title }}
                  {{ scope.row.buy_back == 0 ? "不复购" : "复购" }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="适用宠物" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.apply_type.title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="品牌" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.brand_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="分类" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.category_info.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="规格/条码/库存/包装/售价">
            <template slot-scope="scope">
              <div>
                <div
                  style="display: flex; padding: 5px"
                  v-for="(item, index) in scope.row.skus_list"
                  :key="index"
                >
                  <div class="column" style="margin-right: 10px">
                    <span>
                      <span v-if="$public.isNull(item.image)">{{
                        item.skus_name
                      }}</span>
                   
                      <el-tooltip v-else placement="top" effect="light">
                        <div slot="content">
                          <img :src="item.image[0]" style="width: 300px" />
                        </div>
                        <span>{{ item.skus_name }}</span>
                      </el-tooltip>
                    </span>
                    <el-popover placement="right" width="400" trigger="click" v-if="item.stock_detail[0]">
                      <span
                      v-for="(stockItem, index) in item.stock_detail"
                      :key="index"
                      style="margin-right: 5px"
                    >
                      <span
                        style="color:'#1890FF'">
                        {{ stockItem.shop_name }}:{{
                          stockItem.stock_show_info
                        }}
                      </span>
                    </span>
                      <el-button
                        slot="reference"
                        style="margin-left: 10px"
                        icon="el-icon-view"
                        size="mini"
                        type="text"
                      >
                      </el-button>
                    </el-popover>
                    <span style="color: black;font-size: 17px;margin: 0 20px;">{{
                        item.barcode?item.barcode:''
                      }}</span>
                      <i class="el-icon-printer" v-if="item.barcode" @click="printer(item,scope.row.title)"></i>
                  </div>

                  <div class="column">
                    <div
                      style="margin: 1px"
                      v-for="(item1, index1) in item.sale_way"
                      :key="index1"
                    >
                      {{ item1.packing_way_name }}
                      <span style="margin: 0 30px">标准价￥{{ item1.pprice }}</span>
                      <span style="margin: 0 30px" v-if="item1.mprice">会员价￥{{ item1.mprice }}</span>
                    </div>
                  </div>
                  <div class="column" v-if="item.stop_sale_time != null">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.stop_sale_time"
                      placement="right"
                      v-if="item.status == 0"
                    >
                      <span>暂停</span>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.stop_sale_time"
                      placement="right"
                      v-if="item.status == -1"
                    >
                      <span>作废</span>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.stop_sale_time"
                      placement="right"
                      v-if="item.status == 1"
                    >
                      <span>启用</span>
                    </el-tooltip>
                    <!-- <span v-if="item.status == 1">启用</span> -->
                  </div>
                  <div class="column" v-if="item.stop_sale_time == null">
                    <span v-if="item.status == 1">启用</span>
                    <span v-if="item.status == 0">暂停</span>
                    <span v-if="item.status == -1">作废</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column  label="适用门店">
						<template slot-scope="scope">
							<div v-for="item in scope.row.shop_info" :key='item.shop_id'>{{item.shop_name}}</div>
						</template>
					</el-table-column> -->
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="uploadImg(scope.row)"
                >上传图片</el-button
              >
              <el-button
                type="text"
                icon="el-icon-edit"
                size="small"
                @click="edit(scope.row.goodsId)"
                v-if="$buttonAuthority('chanpin-goods-edit')"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                size="small"
                @click="deleted(scope.row.goodsId)"
                v-if="$buttonAuthority('chanpin-goods-del')"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <page
          :total="total"
          :page="params.pageIndex"
          :pageSize="params.pageSize"
          @change="changePage"
          style="padding: 10px 0"
        ></page>
      </div>
    </div>

    <el-dialog
      title="商品类型设置"
      :visible.sync="dialogProductType"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form ref="editProductParams" label-width="80px">
        <el-form-item label="类型名称">
          <el-input
            v-model="editProductParams.typeName"
            size="mini"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="warning" @click="onSubmitProductType"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="打印数量"
      :visible.sync="dialogPrintType"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form ref="editProductParams" label-width="80px">
        <el-form-item label="数量">
          <el-input
            v-model="num"
            size="mini"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="warning" @click="onSubmitPrintType(num)"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      v-if="dialogUploadImg_state"
      title="上传图片"
      :visible.sync="dialogUploadImg_state"
      width="60%"
      :close-on-click-modal="false"
      top="5vh"
    >
      <el-form ref="editProductParams" label-width="80px">
        <el-form-item label="主图:">
          <uploadImg
            :fileLists="fileLists1"
            :num="1"
            @sendImg="sendImg1"
          ></uploadImg>
        </el-form-item>
        <el-form-item label="规格:">
          <div>
            <div
              style="border-bottom: 1px solid #ccc; padding-bottom: 10px"
              v-for="(skuItem, skuIndex) in uploadImgParams.skuImages"
              :key="skuItem.skuId"
            >
              {{ skuIndex + 1 }}、{{ skuItem.skuName }}
              <uploadImg
                style="display: inline-block; margin-left: 5px"
                :remark="skuItem.skuId"
                :fileLists="fileLists2[skuIndex]"
                :num="5"
                @sendImg="sendImg2"
              ></uploadImg>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="详情:">
          <uploadImg
            :fileLists="fileLists3"
            :num="5"
            @sendImg="sendImg3"
          ></uploadImg>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button
            style="width: 100px"
            size="small"
            type="warning"
            @click="submit_dialogUploadImg"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import page from "../../../components/page.vue";
import uploadImg from "../../../components/uploadImg.vue";
import {
  // VUE_APP_Url_baseData
  getProductGoodsList, // api.post(`${baseURL2}api/product/goods/list`
  deleteProductGoods, // api.delete(`${baseURL2}api/product/goods`
  getProductTypeList, // api.get(`${baseURL2}api/dict/ProductType/tree`
  setProductType, // api.post(`${baseURL2}api/dict/ProductType/update`
  deleteProductType, // api.delete(`${baseURL2}api/dict/ProductType`
  getProductTypeDl, // api.get(`${baseURL2}api/dict/ProductType/codemodel`
} from "../../../api/productApi.js";
import printJs from "../../../util/print.js";
export default {
  components: {
    page,
    uploadImg,
  },
  data() {
    return {
      fixedHeight: "",
      dialogWashService: false,
      washData: [],
      isHighlight: true,
      params: {
        keyword: "",
        categoryId: "",
        shopId: null,
        pageIndex: 1,
        pageSize: 10,
      },
      total: 0,
      productTypeIds: [],
      categoryData: [],
      dialogProductType: false,
      dialogPrintType:false,
      editProductParams: {
        status: 1,
        category: "商品",
        typeName: "",
        parentId: "",
      },

      storeIds: [],
      // 上传图片
      dialogUploadImg_state: false,
      uploadImgParams: {},
      fileLists1: [],
      fileLists2: [],
      fileLists3: [],
      num:1,
      selectCustomData:''
    };
  },

  methods: {
    printer(value,title){
      console.log(value,title,'????value');
      this.dialogPrintType=true
      this.selectCustomData =  {
          code: Number(value.barcode),
          name: title,
          sku:value.skus_name,
          unit: value.sale_way[0].packing_way_name,
          price:value.sale_way[0].pprice,
          mprice:value.sale_way[0].mprice
        };
    },
    onSubmitPrintType(value){
      let customArray=[]
      for(let j = 0;j<value;j++){
        customArray.push(this.selectCustomData)
      }
      console.log(customArray,'customArray');
      let params = {
          bar_codes: customArray,
        };
        console.log(params,"params");
        printJs.printTicketBarCodeN(params.bar_codes).then((res) => {
          this.$store.commit("set_printUrl", res.msg);
        });
        this.dialogPrintType=false
    },
    // 上传图片
    uploadImg(row) {
      let loading = this.$loading();
      this.$http
        .get(process.env.VUE_APP_Url_8000 + "/api/product/goods/images", {
          prouctId: row.goodsId,
        })
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            let d = res.data;
            this.uploadImgParams = d;

            this.fileLists1 = [];
            if (!this.$public.isNull(d.cover)) {
              this.fileLists1 = [
                { url: d.cover, name: d.cover.substr(d.cover.length - 21) },
              ];
            }
            this.fileLists2 = [];
            if (!this.$public.isNull(d.skuImages)) {
              for (let i = 0; i < d.skuImages.length; i++) {
                let arr = [];
                if (!this.$public.isNull(d.skuImages[i].image)) {
                  for (let a = 0; a < d.skuImages[i].image.length; a++) {
                    arr.push({
                      url: d.skuImages[i].image[a],
                      name: d.skuImages[i].image[a].substr(
                        d.skuImages[i].image[a].length - 21
                      ),
                    });
                  }
                }
                this.fileLists2.push(arr);
              }
            }
            this.fileLists3 = [];
            if (!this.$public.isNull(d.detailImgList)) {
              for (let i = 0; i < d.detailImgList.length; i++) {
                this.fileLists3.push({
                  url: d.detailImgList[i],
                  name: d.detailImgList[i].substr(
                    d.detailImgList[i].length - 21
                  ),
                });
              }
            }

            this.dialogUploadImg_state = true;
          }
        });
    },
    sendImg1(list) {
      this.uploadImgParams.cover = list[0].url;
    },
    sendImg2(list, str) {
      for (let i = 0; i < this.uploadImgParams.skuImages.length; i++) {
        if (this.uploadImgParams.skuImages[i].skuId === str) {
          this.uploadImgParams.skuImages[i].image = [];
          for (let a = 0; a < list.length; a++) {
            this.uploadImgParams.skuImages[i].image.push(list[a].url);
            console.log(this.uploadImgParams.skuImages[i].image);
          }
        }
      }
    },
    sendImg3(list) {
      this.uploadImgParams.detailImgList = [];
      for (let i = 0; i < list.length; i++) {
        this.uploadImgParams.detailImgList.push(list[i].url);
      }
    },
    submit_dialogUploadImg() {
      let params = this.uploadImgParams;
      console.log(params);
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_Url_8000 + "/api/product/goods/update/images",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getProductGoodsList();
            this.dialogUploadImg_state = false;
          }
        });
    },
    //////////////////////////////////////////////////////////////////////////
    getProductGoodsList() {
      getProductGoodsList(this.params).then((res) => {
        if (res.code == 0) {
          console.log(res);
          this.washData = res.data.data;
          this.total = res.data.count;
        }
      });
    },
    clickSearch() {
      this.params.pageIndex = 1;
      this.getProductGoodsList();
    },
    changePage(val) {
      this.params.pageIndex = val;
      this.getProductGoodsList();
    },
    addGoods() {
      this.$router.push({
        path: "/chanpin/addgoods",
      });
    },
    getStoreInfo(shopinfo) {
      this.editParams.shop_info = shopinfo;
    },

    edit(id) {
      this.$router.push({
        path: "/chanpin/addgoods",
        query: {
          id,
        },
      });
    },
    deleted(id) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteProductGoods({
            id,
          }).then((res) => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getProductGoodsList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    lookdetail(id) {
      console.log(id);
    },
    renderContent(h, { node, data }) {
      return (
        <span class="custom-tree-node">
          <span>{node.label}</span>
          <span class="custom-tree-btn" >
            <el-button
            v-if="$buttonAuthority('chanpin-goods-sort')"
              size="mini"
              type="text"
              icon="el-icon-plus"
              on-click={() => this.addProductType(data)}
            ></el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              on-click={() => this.editProductType(data)}
            ></el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-delete"
              on-click={() => this.remove(node, data)}
            ></el-button>
          </span>
        </span>
      );
    },
    addProductType(data) {
      if (data) {
        this.editProductParams.parentId = data.id;
        this.editProductParams.typeName = "";
        this.editProductParams.typeId = "";
      } else {
        this.editProductParams.parentId = this.categoryData[0].id;
        this.editProductParams.typeName = "";
      }

      this.dialogProductType = true;
    },

    onSubmitProductType() {
      if (!this.editProductParams.typeName) {
        this.$message({
          type: "warning",
          message: "类型名称不能为空",
        });
      } else {
        setProductType(this.editProductParams).then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "设置成功",
            });
            this.dialogProductType = false;
            this.getProductTypeList();
          }
        });
      }
    },
    remove(node, data) {
      this.$confirm(
        "请谨慎操作！此操作将永久删除此类型，那么关联此类型的服务将被波及?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          deleteProductType({
            id: data.id,
          }).then((res) => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getProductTypeList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getProductTypeList() {
      getProductTypeList({
        category: "商品",
      }).then((res) => {
        if (res.code == 0) {
          console.log(res.data,"商品");
          this.categoryData = res.data;
        }
      });
    },
    editProductType(data) {
      console.log(data);
      this.dialogProductType = true;
      this.editProductParams.typeId = data.id;
      this.editProductParams.typeName = data.label;
      this.editProductParams.parentId = "";
    },
    handleNodeClick(data) {
      this.params.categoryId = data.id;
      this.getProductGoodsList();
    },
    changeCategory(val) {
      if (val.length > 0) {
        getProductTypeDl({
          id: val[val.length - 1],
        }).then((res) => {
          if (res.code == 0) {
            this.editParams.basic_info.category_info["name"] = res.data.name;
            this.editParams.basic_info.category_info["_id"] = res.data._id;
            this.editParams.basic_info.category_list = res.data.parent_all;
          }
        });
      }
    },
    resetProductType() {
      this.isHighlight = false;
      this.params.categoryId = "";
      this.getProductTypeList();
    },
  },
  created() {
    this.fixedHeight = document.documentElement.clientHeight - 86;
    this.getProductGoodsList();
    this.getProductTypeList();
  },
};
</script>

<style lang="scss" scoped>
.page {
  .searchbox {
    background-color: #fff;
    display: flex;
    height: 72px;
    align-items: center;
    .mr {
      margin-right: 10px;
    }
  }

  .con {
    display: flex;
    margin-top: 10px;

    .left {
      width: 180px;
      background-color: #fff;
      margin-right: 20px;
      padding: 10px;
      &::-webkit-scrollbar {
        width: 4px;
        // height: 4px;
      }
      .elTree {
        font-size: 12px;
        ::v-deep .custom-tree-node {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 12px;
          padding-right: 8px;
        }
        ::v-deep .custom-tree-btn {
          display: none;
        }
        ::v-deep .custom-tree-node:hover .custom-tree-btn {
          display: block;
        }
      }
    }

    .table {
      flex: 1;
      background-color: #fff;
      padding: 0 20px;
    }
  }
}
</style>
